import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDELETE_modelAnswerMutation, useGET_modelAnswersQuery } from 'redux/api/modelAnswersApi'
import ModelAnswerForm from 'components/organisms/forms/ModelAnswerForm'
import { ActionType, RoleType } from 'types'
import DialogPopup from 'components/molecules/DialogPopup'
import { Accordion, AccordionDetails, AccordionSummary, Button } from '@mui/material'
import { Delete, ExpandMore } from '@mui/icons-material'
import { useErrorAlert } from 'utils/customHooks/useErrorAlert'
import { useSuccessAlert } from 'utils/customHooks/useSuccessAlert'

interface IProps {
  action: ActionType
  assignmentId?: string
  viewOnly: boolean
  userRole: RoleType
}

const slideProps = {
  mountOnEnter: true,
  unmountOnExit: true,
  timeout: { enter: 225, exit: 195 }
};

const ModelAnswers: FC<IProps> = ({ assignmentId }) => {
  const { t } = useTranslation()

  const [createPopupOpen, setCreatePopupOpen] = useState(false)

  const [
    deleteEntity,
    { isSuccess: deleteSuccess, error: deleteError },
  ] = useDELETE_modelAnswerMutation()

  useErrorAlert(deleteError)
  useSuccessAlert(deleteSuccess ? t('alerts.entity-removed',{entity: t('common.model-answer')}) : '')

  const { isLoading: isLoading, data: modelAnswers } = useGET_modelAnswersQuery({assignment_id: assignmentId})
  const data = modelAnswers?.results ?? []


  return (
    <>
      <div style={{ marginBottom: '20px' }}>
        <Button
          variant='contained'
          color='success'
          onClick={() => {
            setCreatePopupOpen(true)
          }}
          sx={{ marginLeft: '5px' }}
        >
          {t('common.add-model-answer')}
        </Button>
      </div>

      {data.map((answer, index) => 
                          <Accordion 
                            TransitionProps={slideProps}
                            key={answer.id} >
                            <AccordionSummary expandIcon={<ExpandMore />}>
                                 {t('common.model-answer')} {index+1}
                            </AccordionSummary>
                            <AccordionDetails>  
                                <>
                                  <span dangerouslySetInnerHTML={{ __html: answer.text }} />

                                  {t('common.is-shown-to-students')}: <b>{answer.is_shown_to_students ? t('common.yes') : t('common.no')}</b>

                                  <div style={{ marginTop: '20px' }}>
                                    <Button
                                      size='small'
                                      variant='contained'
                                      color='error'
                                      className='small-button'
                                      onClick={() => deleteEntity({assignment_id: assignmentId, id: answer.id.toString()})}
                                    >
                                      <Delete />
                                      {`${t('common.delete')}`}
                                    </Button>
                                  </div>
                                </>   

                            </AccordionDetails>
                          </Accordion>  
                        ) 
        }   


      <DialogPopup
        title={t('common.add-model-answer')}
        open={createPopupOpen}
        onClose={() => setCreatePopupOpen(false)}
        popupWidth={'1000px'}
      >
        <ModelAnswerForm 
          assignmentId={assignmentId}
          onCreate={() => {
            setCreatePopupOpen(false)
          }}
        />
      </DialogPopup>
    </>
  )
}

export default ModelAnswers
